import { jsx as _jsx } from "react/jsx-runtime";
const APP_STORE_URL = 'https://apps.apple.com/us/app/histotime-%E3%83%92%E3%82%B9%E3%83%88%E3%82%BF%E3%82%A4%E3%83%A0-%E3%82%B7%E3%83%B3%E3%83%97%E3%83%AB%E3%81%AA%E6%99%82%E9%96%93%E7%AE%A1%E7%90%86/id6733235215';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=jp.co.itsol.histotime';
const STORE_BADGES = [
    {
        href: APP_STORE_URL,
        src: 'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/ja-jp?size=250x83',
        alt: 'App Storeからダウンロード',
        height: 'h-12'
    },
    {
        href: GOOGLE_PLAY_URL,
        src: 'https://play.google.com/intl/ja/badges/static/images/badges/ja_badge_web_generic.png',
        alt: 'Google Playで手に入れよう',
        height: 'h-16'
    }
];
const CTAButton = ({ align = 'center' })=>/*#__PURE__*/ _jsx("div", {
        className: `flex flex-col gap-4 sm:flex-row ${align === 'center' ? 'items-center justify-center' : 'items-center justify-start'}`,
        children: STORE_BADGES.map((badge)=>/*#__PURE__*/ _jsx("a", {
                href: badge.href,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "transition-opacity hover:opacity-80",
                children: /*#__PURE__*/ _jsx("img", {
                    src: badge.src,
                    alt: badge.alt,
                    className: badge.height
                })
            }, badge.alt))
    });
export default CTAButton;
